import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/resourceservice');

export const resourceReleaseNotesApiPaths = {
  list: withRoot('/release-notes/:productName'),
  byId: withRoot('/release-notes/:productName/:releaseNoteId'),
} as const;

export const getResourceReleaseNotesApiUrl = {
  list: (product: string) => replacePathParams(resourceReleaseNotesApiPaths.list, { productName: product }),
  byId: (product: string, releaseNoteId: string) =>
    replacePathParams(resourceReleaseNotesApiPaths.byId, { productName: product, releaseNoteId }),
};
